import { SelectionRange } from "@sandbox/code-editor"
import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "store"
import { openFile, sandboxFilesSelector } from "store/features"

interface PlaygroundHandlerProps {
  children?: React.ReactNode,
  dataTestId: string
}

export const PlaygroundHandler = ({ children, dataTestId }: PlaygroundHandlerProps) => {
  const dispatch = useAppDispatch();
  const sandbox = useAppSelector((state) => state.activeSandbox.metadata);
  const files = useAppSelector(sandboxFilesSelector)
  const globalSettings = useAppSelector((state) => state.settings.global);
  const layoutSettings = useAppSelector((state) => state.settings.layout);
  const { activeFilePath, filePath, focusMode, startLineNumber, endLineNumber } = globalSettings;

  useEffect(() => {
    if (!sandbox)
      return;

    const openedFiles = [];

    if (filePath)
      openedFiles.push(...filePath.filter((item) => item !== activeFilePath))
    else {
      const entryFile = files.find((file) => file.entry);
      if (entryFile)
        openedFiles.push(entryFile.filePath);
    }

    const alwaysVisible = layoutSettings.filePanel === "hidden";
    openedFiles.forEach((item) => dispatch(openFile({ filePath: item, alwaysVisible })));

    if (filePath?.length && activeFilePath)
      dispatch(openFile({ filePath: activeFilePath, focusMode, selection: getSelection(startLineNumber, endLineNumber), alwaysVisible }));
    else if (filePath?.length)
      dispatch(openFile({ filePath: openedFiles[0], focusMode, selection: getSelection(startLineNumber, endLineNumber), alwaysVisible }));

  }, [sandbox, globalSettings]);

  return <div data-testid={dataTestId}>{children}</div>
}

function getSelection(startLineNumber?: number, endLineNumber?: number): SelectionRange | undefined {
  if (startLineNumber === undefined)
    return undefined;

  if (startLineNumber !== undefined && endLineNumber === undefined)
    return {
      startLineNumber,
      endLineNumber: startLineNumber,
      startColumn: 0,
      endColumn: Infinity
    }

  if (startLineNumber !== undefined && endLineNumber !== undefined)
    return {
      startLineNumber,
      endLineNumber,
      startColumn: 0,
      endColumn: Infinity
    }
}